var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-quality-modal-component" }, [
    _c("div", { staticClass: "room-setting-modal" }, [
      _c("div", { staticClass: "room-setting-header" }, [
        _c(
          "div",
          { staticClass: "room-setting-title-wrapper" },
          [
            _c("h5", { staticClass: "room-setting-title" }, [
              _vm._v(_vm._s(this.$t("displayQuality.title"))),
            ]),
            _c("GrmCloseBtn", { on: { click: _vm.onClose } }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "room-setting-body" }, [
        _c("div", { staticClass: "room-setting-content-text-box" }, [
          _c("p", { staticClass: "room-setting-content-text" }, [
            _vm._v(_vm._s(this.$t("displayQuality.text"))),
          ]),
        ]),
        _c("div", { staticClass: "room-setting-input-box" }, [
          _c("div", { staticClass: "room-set-block-btn-box" }, [
            _c(
              "ul",
              _vm._l(_vm.qualityList, function (quality) {
                return _c(
                  "li",
                  {
                    key: quality.type,
                    class: { selected: _vm.userVideoQuality == quality.type },
                    on: {
                      click: function ($event) {
                        return _vm.onClickQuality(quality.type)
                      },
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "room-set-block-btn",
                        attrs: { tabindex: "1" },
                      },
                      [_vm._v(_vm._s(quality.name))]
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }